var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{class:{'line-through': _vm.discountPercentage, 'text-gray-600': _vm.discountPercentage}},[_vm._v(_vm._s(_vm.price.value))]),(_vm.discountPercentage)?_c('span',[_vm._v(" "+_vm._s(_vm.discountedPrice)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.price.currency)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }